import Vue from 'vue';
import Vuex from 'vuex';

import mbc from './mbc';
import sso from './sso';
import pmt from './pmt';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    pmt,
    mbc,
    sso,
  },
  state: {
    isMobile: false,
    companyId: '',
    accessToken: '',
    memberSourceId: '',
    memberId: '',
    couponName: '', // coupon名稱
    couponImage: '', // coupon圖片
    couponDesc: '',
    couponLimitCnt: '',
    limitDesc: '',
    memberAcntNo: 0,
    termsType: '',
    showTerms: false,
    couponNo: null,
    activityNo: null,
    customizeCouponActivity: null,
    limitEnd: 2626428940000,
    beforeWording: '',
    afterWording: '',
    customerShopUrl: null,
    loading: false,
    activityName: '',
  },
  mutations: {
    set(state, { name, value }) {
      state[name] = value;
    },
    push(state, { name, value }) {
      state[name].push(value);
    },
    delete(state, { name }) {
      state[name] = null;
    },
    setShowTerms(state, type) {
      state.showTerms = true;
      state.termsType = type;
    },
  },
});
